import React from 'react';
import { FinalFormInput } from '@utex/ui-kit';
import { USDEquivalent } from './Rate';

interface Props {
  name: string;
  amount: number;
  currency: string;
}

const currencyToLabel: Record<string, string> = {
  USD: '$',
  RUB: '₽',
};

export const AmountInput: React.FC<Props> = ({ name, amount, currency }) => (
  <FinalFormInput
    name={name}
    id={name}
    label={currencyToLabel[currency] || currency}
    type="number"
    allowedSymbols={/\d|\.|\,/g}
    isLabelShort
    placeholder="0"
    view="big"
    hintView="error"
    hintPosition="right"
    caption={currency !== 'USD' && <USDEquivalent amount={amount} />}
  />
);
